import React, { useState, useEffect, useRef } from 'react';
import * as comMod from '../../commonModule'
import { useDispatch, useSelector } from 'react-redux';
import * as mui from '../common/materialUi';
import * as Actions from '../../Actions';
import Button from '@material-ui/core/Button';
import { blue, green, grey, pink, red, teal, yellow } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import * as sfp from '../common/StdFormParts';
import { useHistory, useParams } from 'react-router';
import { GoBackButton } from '../common/commonParts';
import { setRecentUser } from '../../albCommonModule';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { CheckBox } from '@material-ui/icons';
import { faSleigh } from '@fortawesome/free-solid-svg-icons';

const hiddenInput = 'hiddenInput';

const useStyles = makeStyles({
  stopUseButtonRoot: {
    paddingTop: 18, paddingLeft: 8,
    '& .MuiButton-label' :{color: red[600]}
  },
  stopUseInner:{
    '& .chkBox': {padding: 16, width: 160, paddingTop: 8},
    '& .disc': {padding: 16, flex: 1, color: red[600], lineHight: 1.5}
  },
  links: {
    marginTop: 48,
    '& > a > .MuiButton-text': {
      // margin: theme.spacing(1),
      padding: 0,
      color: '#fff'
    },
  },
  nextUserNotation:{
    flex: 1, display: 'flex', alignItems: 'center',
    paddingLeft: 8,
    '& > div':{
      background: blue[900], color:yellow[200],
      fontSize: '.8rem', padding: 8,
    }
  },
  sameNameButton:{
    background: red[800],color: '#fff',
    '&:hover': {background: red[700]}
  },
  userEditRoot: {
    '& .outer': {
      marginTop: 32, maxWidth: 800, paddingRight: 8,
      marginLeft: 200, 
    },
    '@media screen and (min-width: 1200px)':{
      '& .outer': {
        marginLeft: 'calc(100vw / 2 - 400px)', 
      },
    },
    '& .editTitle': {
      textAlign: 'center', color: teal[800], fontWeight: '600',
      position: 'relative', borderBottom: '1px solid ' + teal[300], 
      padding: 8, background: teal[50], 
    },
    '& form': {
      minWidth: 600, padding: 4, paddingTop: 0, 
    },
    '& .lastUpdate': {
      position: 'absolute', right: 8, top: 8, fontSize: '.7rem',
      color: grey[800], fontWeight: 400,
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 800,
    },
    '& .MuiDialogContent-root' :{
      margin: 0,
      padding: 0,
      overflowX: 'hidden', // この設定がないと横スクロールバーが出ちゃう
    },
    '& .MuiDialogTitle-root' : {
      padding: 0,
    },
  },

})

const Links = (props) => {
  const { tab, settab } = props;
  const classes = useStyles();
  return (<>
    <div className={'linksTab ' + classes.links} >
      <a 
        onClick={() => settab(0)} 
        className={(tab === 0) ? 'current' : ''}
      >
        <Button tabIndex={-1}>基本</Button>
      </a>
      <a 
        onClick={() => settab(1)} 
        tabIndex='-1' className={(tab === 1) ? 'current' : ''}
      >
        <Button tabIndex={-1} >口座情報</Button>
      </a>
    </div>
  </>)
}
// ユーザー情報に次の情報があるかどうか
// 次の情報があるときは表示を行う
export const NextUserDisp = (props) => {
  const classes = useStyles();
  const {thisUser} = props;
  const Notation = () => (
    <div className={classes.nextUserNotation}>
      <div>
        変更は{thisUser.next.slice(0, 7)}以降に反映されません。
      </div>
    </div>
  )
  if (thisUser.next)  return <Notation />
  else return null;
}

// 仮入力用に未入力のフィールドの値を作成する
const userDatasFillEmpty = (prms) => {
  const {userDatas, users, checked} = prms;
  if (!checked) return false;
  const tobeFilled = [
    'lname', 'fname', 'klname', 'kfname', 'birthday', 'hno', 
    'volume', 'priceLimit', 'scity_no', 'scity', 'startDate', 'contractDate', 
    'lineNo', 'plname', 'pfname', 'pklname', 'pkfname', 'brosIndex', 'pphone'
  ];
  // ユニークな仮受給者証番号を作成
  let hno;
  for (let i = 1; i <= 999; i++){
    hno = comMod.zp(i, 3);
    if (!users.find(e=>e.hno === hno)) break;
  }
  userDatas['hno'] = hno;
  tobeFilled.forEach(e=>{
    // 仮登録では兄弟設定は強制的に解除
    if (e === 'brosIndex'){
      userDatas[e] = '0'
    }
    if (userDatas[e]) return false;
    // 名前として処理
    if (e.includes('name') && !e.includes('k')){
      userDatas[e] = '名無し'
    }
    // かなとして処理
    else if (e.includes('name') && e.includes('k')){
      userDatas[e] = 'ななし'
    }
    else if (e === 'birthday'){
      const t = new Date();
      t.setFullYear(t.getFullYear() - 5);
      t.setMonth(0);
      t.setDate(1);
      userDatas[e] = comMod.formatDate(t, 'YYYY-MM-DD');
    }
    else if (e === 'volume'){
      userDatas[e] = 0;
    }
    else if (e === 'scity_no'){
      if (users.length){
        userDatas[e] = users[0].scity_no;
      }
      else {
        userDatas[e] = '012345'
      }
    }
    else if (e === 'scity'){
      if (users.length){
        userDatas[e] = users[0].scity;
      }
      else {
        userDatas[e] = '架空自治体'
      }
    }
    else if (e === 'contractDate' || e === 'startDate'){
      const t = new Date();
      t.setMonth(0);
      t.setDate(1);
      userDatas[e] = comMod.formatDate(t, 'YYYY-MM-DD');
    }
    else if (e === 'lineNo'){
      userDatas[e] = 1;
    }
    else if (e === 'brosIndex'){
      userDatas[e] = 0;
    }
    else if (e === 'pphone'){
      userDatas[e] = '045-000-0000'
    }
    else if (e === 'priceLimit'){
      userDatas[e] = 4600
    }
  });
}

export const UserEditNoDialog = (props) =>{
  // stateのopenで開く、uidsはuidを持つ
  // editOnで修正モード、uidに従って修正を行う
  // const {editOn,} = props;
  const allState = useSelector(state=>state);
  const {
    hid, bid, stdDate, dateList, users, nextUsers, controleMode,
    serviceItems
  } = allState;
  const history = useHistory();
  const prms = useParams().p;
  const uids = prms.replace(/[^0-9]/g, '');
  const addnew = prms.includes('addnew');
  const dispatch = useDispatch();
  const classes = useStyles();
  // const lcClasses = useStyle();
  const [sameName, setSameName] = useState(false); // 同姓同名チェック用
  // 複数サービスを監視
  const [curService, setCurService] = useState(false);
  // 未収力項目を仮入力するためのボタン表示制御
  const [tempInput, setTempInput] = useState({
    style: {display: 'none'},
    checked: false,
  });
  // 所属のユニークなリストを作成する
  const belongs1Set = new Set();
  const belongs2Set = new Set();
  users.map(e=>{
    belongs1Set.add(e.belongs1);
    belongs2Set.add(e.belongs2);
  });
  const belongs1List = Array.from(belongs1Set);
  const belongs2List = Array.from(belongs2Set);
  // 修正モードかどうかはパラメータで判断
  const editOn = uids? true: false;
  const titleStr = (editOn) ? '利用者修正削除' : '利用者追加';
  const locPrms = comMod.locationPrams();
  const goBack = comMod.fdp(locPrms, 'detail.goback');
  // sindexの最大値を作成する 新規追加のときはこれを使う
  // const aryMax = (a, b) => {return Math.max(a, b)};
  // const sindexMax = (users.length) 
  // ? users.map(e=>e.sindex).reduce(aryMax) + 10 : 0;
  const sindexMax = users.reduce((v, e)=>(e.sindex > v? v = e.sindex: v), 0);
  // uidに従ったuserの情報 後からメンバーを見に行くので空のobjで初期化
  const thisUser = (uids)? comMod.getUser(uids, users, nextUsers) : {};
  // 利用停止のエレメントを開くかどうか。初期値として終了日に今月の日付が入っていること
  const [openStopUse, setOpenStopUse] = useState(
    thisUser.endDate &&
    thisUser.endDate.slice(0, 7) === stdDate.slice(0, 7)
  );
  // 利用停止のチェックボックス用 初期値は上記と同じ値を取る
  const [stopUse, setStopUse] = useState(
    thisUser.endDate &&
    thisUser.endDate.slice(0, 7) === stdDate.slice(0, 7)
  )

  // 口座情報用
  // nullが帰ってきたら初期値を設定
  let bi = comMod.fdp(thisUser, 'etc.bank_info', {});
  // 銀行口座項目を配列にしておく
  const bankInfoNames = [
    '口座名義人', '口座番号', '口振初回', '店舗番号', 
    '金融機関番号', '預金種目', '顧客コード',
  ]
  // 銀行口座項目ステイトに書き込む初期値
  const biIni = {};
  bankInfoNames.forEach(e=>{biIni[e] = ''});
  const bankInfo = (!Object.keys(bi).length || !bi)? biIni: bi;
  // 該当スケジュールが存在するかどうか
  const uSchedule = useSelector(state=>state.schedule['UID' + uids]);
  const existUsch = uSchedule 
  ? Object.keys(uSchedule).filter(e=>e.match(/^D2[0-9]*/)).length : 0;
  // 当月のスケジュールが存在せず当月に作成されたスケジュールであれば削除可能にする
  // ユーザーが一人のときも削除不可 -> 削除可能とする 2022/09/21変更
  const enableDelete = (
    // thisUser.date === stdDate && existUsch === 0 && users.length > 1
    thisUser.date === stdDate && existUsch === 0
  );
  
  // ユーザーステイト日付から年月を示す文字列を得る
  const lastUpdate = !thisUser.date? ''
  : thisUser.date.slice(0, 4) + '年' + thisUser.date.slice(5, 7) + '月'
  // // 送迎先の初期値を設定
  // const destListInit = (comMod.findDeepPath(thisUser, 'etc.destList') === null)?
  //   ['自宅', '学校',] : thisUser.etc.destList;
  // 行き先指定するためのstate
  const [destList, setDestList] = useState([]);
  // 削除ボタン用
  const [deleteConfirm, setDeleteConfirm] = useState(
    {flg: false, label: '削除', buttonClass: ''}
  )
  // dialog内のタブ
  const [tab, setTab] = useState(0);
  // urlが口座情報を示していたら口座情報修正を開く それ以外なら一般項目
  useEffect(()=>{
    const href = window.location.href;
    if (href.indexOf('bankinfo') > -1){
      setTab(1);
    }
    else{
      setTab(0);
    }
  }, []);
  const isFirstRender = useRef(false)
  useEffect(() => { // このeffectは初回レンダー時のみ呼ばれるeffect
    isFirstRender.current = true
  }, [])

  useEffect(()=>{
    if(isFirstRender.current) { // 初回レンダー判定
      isFirstRender.current = false // もう初回レンダーじゃないよ代入
    }
    else {
      console.log('stdDate moved.')
    }

  }, [stdDate]);

  const formId = '#fgr649hg';
  // キーボード制御
  const keyHandler = (e) =>{
    if (e.which === 13 && e.shiftKey && e.ctrlKey){
      cancelSubmit();
    }
    else if (e.which === 13 && e.shiftKey){
      const forBlur = document.querySelector(`#${hiddenInput}`);
      forBlur.focus();
      e.persist();
      setTimeout(() => {
        handleSubmit(e);
      }, 100);
    }
  }
  const daysOfMonth = dateList.length;
  // 利用停止用に月末の文字列を作成しておく
  const sda = stdDate.split('-');
  const endOfMonthStr = comMod.formatDate(
    comMod.getDateEx(sda[0],sda[1],0).dt, 'YYYY-MM-DD'
  );
  const handleSubmit = (e, deleteBankInfo)=>{
    e.preventDefault();
    // 値が必要なエレメント
    const inputs = document.querySelectorAll(formId + ' input');
    const selects = document.querySelectorAll(formId + ' select');
    // エラーメッセージ用のノード
    const errMsgDisp = document.querySelector(formId + ' .errMsg span');
    errMsgDisp.textContent = '';
    // 必須項目が入力されているか
    const notFilled = comMod.checkRequireFilled([inputs, selects]);
    // 基本項目のタブであれば銀行口座情報の未入力は無視する
    if (tab === 0){
      bankInfoNames.forEach(e=>{
        const p = notFilled.findIndex(f=>f === e);
        if (p > -1){
          notFilled.splice(p, 1);
        }
      })
    }
    if (notFilled.length && tab === 0){
      errMsgDisp.textContent = `
        必要な項目が入力されていません。
        仮登録をするときはチェックをしてから再度書き込みを行って下さい。
        仮登録を行うと無効な入力は無視され、受給者証番号は3桁の仮番号となります。
      `;

      console.log('notFilled', notFilled);
      const t = {...tempInput, style:{display: 'inline'}};
      setTempInput(t);
      if (!tempInput.checked){
        return false;
      }
    }
    else if (notFilled.length){
      errMsgDisp.textContent = `必要な項目が入力されていません。`;
      return false;
    }
    // 複数サービス設定時のエラー
    const multiServiceError = document.querySelector(formId + ' .multiServiceError');
    if (multiServiceError){
      errMsgDisp.textContent = `
        複数サービスの設定を確認してください。単一サービス利用の場合はサービス種別で
        複数サービスを選択しないでください。
      `;
      return false;
    }
    // エラーがないか helperテキストエラーのセレクタを定義
    const errOccured = document.querySelectorAll(
      formId + ' .MuiFormHelperText-root.Mui-error'
    );
    if (errOccured.length){
      if (!tempInput.checked){
        errMsgDisp.textContent = `
          エラーの箇所をご確認下さい。
          仮登録をするときはチェックをしてから再度書き込みを行って下さい。
          仮登録を行うと無効な入力は無視され、受給者証番号は3桁の仮番号となります。
        `;
        const t = {...tempInput, style:{display: 'inline'}};
        setTempInput(t);
        return false;
      }
    }
    // フォームの値を取得 disabledも取得 空白入力も取得
    const userDatas = comMod.getFormDatas([inputs, selects], true, true);
    // 複数サービス入力時の対応
    if (userDatas.service === '複数サービス'){
      let conSvc = ''
      Object.keys(userDatas).filter(e=>e.includes('multiService')).forEach(e=>{
        if (userDatas[e]){
          conSvc += (e.replace('multiService', '') + ',')
        }
        delete userDatas[e];
      });
      // 末尾のカンマを削除してサービスを書き換え
      userDatas.service = conSvc.replace(/,$/, '')
    }
    // エラーが発生している箇所のname属性を配列化
    // nodelistを配列化、エラー表示エレメントからたどってinput要素のname属性を取得
    const errNames = Array.from(errOccured).map(
      e=>e.parentNode.querySelector('input').name
    )
    // 仮入力のときはエラー発生箇所のデータを削除
    if (tempInput.checked){
      errNames.map(e=>{userDatas[e] = ''});
    }
    // 未入力部分を補完する
    userDatasFillEmpty({userDatas, users, checked: tempInput.checked})
    // 必要なデータ変更を行う 名字と名前の連結 未入力の場合を想定する
    const cn = (a, b) =>{
      a = (a) ? a : '';   b = (b) ? b : '';
      return ((a && b) ? a + ' ' + b : a + b)
    }
    userDatas.name = cn(userDatas.lname, userDatas.fname);
    userDatas.pname = cn(userDatas.plname, userDatas.pfname);
    userDatas.kana = cn(userDatas.klname, userDatas.kfname);
    userDatas.pkana = cn(userDatas.pklname, userDatas.pkfname);
    const ages = comMod.getAge(userDatas.birthday);
    userDatas.age = ages.age;
    userDatas.ageNdx = ages.ageNdx;
    userDatas.ageStr = ages.flx;

    // これだけ半角変換が効かないので
    userDatas.scity_no = comMod.convHankaku(userDatas.scity_no);
    // 法人事業所idの付加
    userDatas.hid = hid;
    userDatas.bid = bid;
    userDatas.stdDate = stdDate;
    // 日付の空白は1989年とかに解釈されるので
    userDatas.contractEnd = (!userDatas.contractEnd)?'0000-00-00':userDatas.contractEnd;
    // 管理タイプ未入力だとエラーになる
    userDatas.kanri_type = (userDatas.kanri_type) ? userDatas.kanri_type: '';
    // 利用停止のステイトを見て利用終了データを作成する
    userDatas.endDate = stopUse ? endOfMonthStr: '0000-00-00';
    
    userDatas.date = stdDate; // 追加 2022/01/03
    // 同姓同名のチェック
    if (!editOn){
      const s = users.find(e=>e.name === userDatas.name);
      if (s){
        errMsgDisp.textContent = '二重登録しようとしていませんか？';
        if (!sameName){
          setSameName(true);
          return false;
        }
      }
    }

    // storeの更新
    // フォームの項目で不足しているパラメータがあるので従来のパラメータに
    // 上書きする
    userDatas.users = users;
    const newUserData = {...thisUser, ...userDatas};
    // 学齢の計算 追加のときは学齢がないので
    if (newUserData.age === undefined){
      newUserData.age = comMod.getAge(newUserData.birthday).age;
      newUserData.ageNdx = comMod.getAge(newUserData.birthday).ageNdx;
      newUserData.ageStr = comMod.getAge(newUserData.birthday).flx;
    }
    // 新規追加はインデックス最大値を使う
    if (!newUserData.sindex)  newUserData.sindex = sindexMax + 10;
    // 指定があったら口座情報は削除する
    if (deleteBankInfo){
      const bi = comMod.fdp(newUserData, 'etc.bank_info');
      if (bi) delete newUserData.etc.bank_info;
      bankInfoNames.forEach(e=>{
        delete newUserData[e];
      });

    }

    // 口座情報をetc配下に
    newUserData.etc = newUserData.etc? newUserData.etc: {};
    newUserData.etc.bank_info 
    = newUserData.etc.bank_info? newUserData.etc.bank_info: {};
    bankInfoNames.forEach(e=>{
      if (newUserData[e]){
        newUserData.etc.bank_info[e] = newUserData[e];
        delete newUserData[e];
      }
    });
    // ストアの更新 必要なん？
    const userForEdit = {...newUserData};
    if (userForEdit.volume === '0'){
      userForEdit.volume = daysOfMonth - 8; // 原則の日数
      userForEdit.volumeStd = true;
    }
    dispatch(Actions.editUser({...userForEdit}));
    // ここで書き込み送信を行う
    // ここではaパラメータ必須。削除と兼用しているため stdDateも送信する
    // 余分なユーザデータ配列が付与されているので削除
    const sendUserDt = {...newUserData};
    delete sendUserDt.users;
    sendUserDt.date = stdDate;
    sendUserDt.etc = JSON.stringify(sendUserDt.etc);
    dispatch(Actions.updateUser({...sendUserDt, a:'sendUserWithEtc'}));
    document.querySelector(formId).reset();
    setRecentUser(uids);
    // 追加のとき、recentuserを保存できないためcontrolemodeにdispatchする
    // timestampを追加して直近のデータのみ扱うようにする
    if (!uids){
      const ts = new Date().getTime();
      const hno = newUserData.hno;
      const t = {...controleMode, appendUser:{hno, ts}};
      dispatch(Actions.setStore({controleMode: t}));
    }
    if (goBack){
      history.push(goBack)
    }
    else{
      history.goBack(); // 戻る
    }
  }
  const cancelSubmit = ()=>{
    // dispatch(Actions.setSnackMsg('変更はキャンセルされました。', ''))
    if (goBack){
      history.push(goBack);
    }
    else{
      history.goBack();
    }
  }
  const deleteUser = ()=>{
    const uid = comMod.convUID(uids).num;
    if (!deleteConfirm.flg){
      setDeleteConfirm({
        flg: true, label: '削除実行', buttonClass: 'buttonStrong'
      });
      const errMsgDisp = document.querySelector(formId + ' .errMsg span');
      errMsgDisp.textContent = 
        `利用者の削除を行うと当月以降のこの利用者の操作に影響があります。` +
        `充分に注意して削除して下さい。利用停止の場合は利用停止の処理を行って下さい。`;
      return false;
    }
    // storeから削除実行
    let prms = {
      uid, users, delete:true,
    }
    dispatch(Actions.editUser(prms));
    // ここではaパラメータ必須。削除と兼用しているため
    prms = {
      hid, bid, uid: uids, a: 'removeUser', date: stdDate,
    }
    dispatch(Actions.updateUser(prms));
  }
  // const lastUpdateStyle = {
  //   position: 'absolute',top: 8, right: 8, color: '#222', fontSize: '.8rem'
  // }
  const lastUpdateStr = lastUpdate? '最終更新: ' + lastUpdate: '';
  // 契約終了日は当月の日付のみ許可する
  // コンポーネントに渡すための日付範囲の指定文字列を作成する
  const monthEnd = comMod.getDateEx(
    stdDate.split('-')[0], stdDate.split('-')[1], 0
  ).dt;
  // const monthEndStr = comMod.formatDate(monthEnd, 'YYYY-MM-DD');
  const contractEndLimit = stdDate + ',2299-12-31'; 
  // フォーム内のパーツをくくるラッパーのスタイル
  // タブによって表示非表示を切り替える。
  // ついでにパデイィングの調整もやってる
  const [formPartsStyle, setFormPartsStyle] = useState({
    main: {display: 'flex', padding: '0 8px'},
    bank: {display: 'none', },
  })
  useEffect(()=>{
    if (tab === 0){
      setFormPartsStyle({
        main: {display: 'flex', padding: '0 8px'},
        bank: {display: 'none', },
      })
    }
    else{
      setFormPartsStyle({
        main: {display: 'none', },
        bank: {display: 'flex', },
      })
    }
  }, [tab]);
  const errMsgStyle={color: red[700], padding: 8, paddingLeft: 16};
  const stopUseChangeHandler = (ev) => {
    setStopUse(ev.target.checked);
  }
  const stopUseComment = () => {
    if (stopUse && !thisUser.next){
      return (
        `利用停止処理が有効になっています。次月以降は表示されません。
        当月の利用や請求は通常通り処理されます。`
      )
    }
    else if (!stopUse && !thisUser.next){
      return (
        `利用停止をチェックして保存すると当月で利用停止処理を行います。次月以降は表示されません。
        当月の利用や請求は通常通り処理されます。`
      )
    }
    else if (stopUse && thisUser.next){
      return (
        `このユーザーの利用停止処理を行いますが当月以降に情報が
        存在するため完全に非表示にはなりません。${thisUser.next.slice(0, 7)}以降の情報を
        確認して下さい。`
      )
    }
    else {
      return (
        `利用停止をチェックして保存するとユーザーの利用停止処理を行いますが当月以降に情報が
        存在するため完全に非表示にはなりません。${thisUser.next.slice(0, 7)}以降の情報を
        確認して下さい。`
      )
    }
  }
  const defService = (serviceItems.length === 1 && addnew)
  ? serviceItems[0]: thisUser.service;
  // 口座情報削除ボタンスタイル設定
  const bankInfoDeleteButtonStyle = {
    ...formPartsStyle.bank, justifyContent: 'flex-end',
  }
  // 口座情報が存在しない場合は削除ボタンを表示しない
  if (bi && Object.keys(bi).length > 1){
    bankInfoDeleteButtonStyle.display = 'flex';
  }
  else{
    bankInfoDeleteButtonStyle.display = 'none';
  }
  // 口座情報の以外は非表示
  if (tab !== 1)  bankInfoDeleteButtonStyle.display = 'none';
  return(<>
    <Links tab={tab} settab={setTab}/>
    <div className={classes.userEditRoot}>
      <div className='outer'>
        <GoBackButton posX={80} posY={60} url={goBack}/>
        <div className='editTitle'>
          {titleStr}
          <div className='lastUpdate'>{lastUpdateStr}</div>
        </div>
        <form 
          id="fgr649hg" autoComplete="off"
          onKeyPress={(e)=>keyHandler (e)}
          style={{paddingTop: 8}}
        >
          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.NameInput
              nameLname={'lname'} nameFname={'fname'}
              labelLname={'名字'} labelFname={'名'}
              required
              def={thisUser.name}
            />
            <sfp.NameInput
              nameLname={'klname'} nameFname={'kfname'}
              labelLname={'みょうじ'} labelFname={'なまえ'}
              required
              kana
              def={thisUser.kana}
            />
            <sfp.DateInput
              name={'birthday'} label={'生年月日'} required
              def={thisUser.birthday}
            />
          </div>

          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.ServiceType 
              def={defService} setService={setCurService} 
              service={curService}
            />
            <sfp.UserType def={thisUser.type} />
            <sfp.HihokenNo def={thisUser.hno} uid={uids}/>
            <sfp.Volume def={
              'volumeStd' in thisUser? '0': thisUser.volume
            } />
          </div>
          {curService === '複数サービス' &&
            <div className='cntRow' style={formPartsStyle.main}>
              <sfp.MultiService def={defService}/>
            </div>
          }
          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.PriceLimit def={thisUser.priceLimit} />
            <sfp.Scity
              def={[thisUser.scity, thisUser.scity_no]}
              label={'支給市区町村'} name={'scity'}
              labelNo={'番号'} nameNo={'scity_no'}
            />
            <sfp.KanriType def={thisUser.kanri_type} />
          </div>

          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.DateInput
              name={'startDate'} label={'利用開始日'} required
              def={thisUser.startDate}
            />
            <sfp.DateInput
              name={'contractDate'} label={'契約日'} required
              def={thisUser.contractDate}
            />
            <sfp.DateInput
              name={'contractEnd'} label={'契約終了日'}
              def={thisUser.contractEnd}
              limit={contractEndLimit}
            />
            <sfp.ContractLineNo
              // name={'endDate'} label={'契約終了日'}
              def={thisUser.lineNo}
            />
          </div>
          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.NameInput
              nameLname={'plname'} nameFname={'pfname'}
              labelLname={'保護者名字'} labelFname={'保護者名'}
              required
              def={thisUser.pname}
            />
            <sfp.NameInput
              nameLname={'pklname'} nameFname={'pkfname'}
              labelLname={'みょうじ'} labelFname={'なまえ'}
              required
              kana
              def={thisUser.pkana}
            />
            <sfp.BrosersIndex def={thisUser.brosIndex} />
          </div>
          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.MailInput
              name={'pmail'} label={'保護者メール'}
              def={thisUser.pmail}
            />
            <sfp.PhoneInput
              name={'pphone'} label={'保護者電話1'} required
              def={thisUser.pphone}
            />
            <sfp.PhoneInput
              name={'pphone1'} label={'保護者電話2'}
              def={thisUser.pphone1}
            />
          </div>

          <div className='cntRow' style={formPartsStyle.main}>
            <sfp.Belongs
              name={'belongs1'} label={'所属1'} options={belongs1List}
              def={thisUser.belongs1}
            />
            <sfp.Belongs
              name={'belongs2'} label={'所属2'} options={belongs2List}
              def={thisUser.belongs2}
            />
            <sfp.ClassRoom def={thisUser.classroom} />
            {addnew === false &&
              <div className={classes.stopUseButtonRoot}>
                <Button 
                  variant='contained'
                  onClick={()=>setOpenStopUse(true)}
                  startIcon={<EmojiPeopleIcon/>}
                >
                  利用停止
                </Button>
              </div>
          
            }
          </div>
          {/* 利用停止の制御 ここだけコンポーネントで作成されたstateで制御される */}
          {openStopUse === true && tab === 0 &&
            <div className={'cntRow ' + classes.stopUseInner}>
              <div className='chkBox'>
                <FormControlLabel
                  control={<Checkbox
                    checked={stopUse}
                    onChange={(ev)=>stopUseChangeHandler(ev)}
                    color='primary'
                  />}
                  label='利用停止'
                />
              </div>
              <div className='disc'>
                {stopUseComment()}
              </div>
            </div>
          }
          <div className='cntRow' style={formPartsStyle.bank}>
            <sfp.BankInfoFormsParts bankInfo={bankInfo} thisUser={thisUser} />

          </div>
          <div className='cntRow' style={bankInfoDeleteButtonStyle}>
            <Button onClick={(e)=>handleSubmit(e, true)}>
              <span style={{color: red[800]}}>口座情報を削除して保存</span>
            </Button>
          </div>
          <div style={{...formPartsStyle.bank, height: 320}}></div>
          <div className='errMsg' style={errMsgStyle}>
            <span></span>
            {/* 仮登録用のボタン */}
            <FormControlLabel style={tempInput.style}
              control={<Checkbox
                checked={tempInput.checked}
                onChange={(ev)=>{
                  setTempInput({...tempInput, checked: ev.target.checked})
                }}
              />}
              label='仮登録'
            />

          </div>
          {/* <sfp.TransferList 
            destList={destList} setDestList={setDestList} 
            uid={uids}
          /> */}
        </form>
        
        <NextUserDisp thisUser={thisUser} />
        <div className='buttonWrapper'>
          {editOn && enableDelete &&
            <mui.ButtonGP
              // color='Error'
              addictionclass={classes[deleteConfirm.buttonClass]}
              label={deleteConfirm.label}
              onClick={deleteUser}
            />
          }
          <mui.ButtonGP
            color='secondary'
            label='キャンセル'
            onClick={cancelSubmit}
          />
          {sameName === false &&
            <mui.ButtonGP
              color='primary'
              label='書き込み'
              type="submit"
              onClick={handleSubmit}
            />
          }
          {sameName === true &&
            // <mui.ButtonGP
            //   addictionclass={lcClasses.sameNameButton}
            //   label='同姓同名として書き込み'
            //   type="submit"
            //   onClick={handleSubmit}
            // />
            <Button className={classes.sameNameButton}
              onClick={handleSubmit}
            >
              同姓同名の利用者として書き込み
            </Button>
          }
          <button id={hiddenInput} style={{
            tabindex: '-1',
            width: 0,
            opacity: 0,  
            // visibility:'hidden'
          }}></button>

        </div>
        {/* <KeyListener/> */}
      </div>
    </div>

  </>)
}
export default UserEditNoDialog;